import React, {useState} from "react";
import {Select} from "antd";
import CountryFlag from "./CountryFlag";
import {Countries} from "../../countries";
import "@Styles/main.scss";

export interface IProps {
    value?: string;
    onChange?: (value?: string) => void;
}

const CountrySelect: React.FC<IProps> = ({value, onChange}: IProps | null) => {
    const [inputValue, setInputValue] = useState<string>();
    const handleOnSearch = (searchWord: string) => {
        setInputValue(searchWord);
    };

    const {Option} = Select;
    const countries = Array.from(Countries, ([key, value]) => ({key, value}));

    return (
        <Select
            placeholder="Select country"
            value={value ? value : null}
            allowClear
            id="countryCode"
            showSearch
            onSearch={handleOnSearch}
            onChange={(e) => onChange?.(e)}
            filterSort={(optionA, optionB) => {
                const a = String(optionA.label).toLowerCase();
                const b = String(optionB.label).toLowerCase();
                const i = inputValue && inputValue.toLowerCase();
                const aSortOrder = optionA?.sortOrder;
                const bSortOrder = optionB?.sortOrder;
                if (inputValue && a === i) {
                    return -1;
                }
                if (inputValue && b === i) {
                    return 1;
                }
                if (inputValue && a.indexOf(i) !== -1 && b.indexOf(i) !== -1 && a.indexOf(i) < b.indexOf(i)) {
                    return -1;
                }
                if (inputValue && a.indexOf(i) !== -1 && b.indexOf(i) !== -1 && a.indexOf(i) > b.indexOf(i)) {
                    return 1;
                }
                if (inputValue && a.indexOf(i) !== -1 && b.indexOf(i) === -1) {
                    return -1;
                }
                if (inputValue && a.indexOf(i) === -1 && b.indexOf(i) !== -1) {
                    return 1;
                }
                // prioritize sortOrder if exists
                if (aSortOrder && bSortOrder && aSortOrder < bSortOrder) {
                    return -1;
                }
                if (aSortOrder && bSortOrder && aSortOrder > bSortOrder) {
                    return 1;
                }
                if (aSortOrder && bSortOrder && aSortOrder === bSortOrder) {
                    return 0;
                }

                return a.localeCompare(b);
            }}
            filterOption={(input, option) => option?.label?.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
            {countries.map((country: { [key: string]: string }, index) => (
                <Option key={index} value={country.key} label={country.value}>
                    <span
                        style={{
                            marginRight: 10,
                        }}
                    >
                      <CountryFlag countryCode={country.key}/>
                    </span>
                    {country.value}
                </Option>
            ))}
        </Select>
    );
};
export default CountrySelect;
